import React from 'react';
import Navigation from '../../components/static/Navigation';
import Footer from '../../components/static/Footer';

import VBDropdown from "@virkesborsen/vb-js-commons/lib/components/new/vbDropdown";


class NHListings extends React.Component {
    constructor() {
        super();
        this.navigation = React.createRef();
        this.state = {
            ddl_options: {
                tag: [],
                country: [],
            },
            filters: {
                tag:null,
                country:null
            }
        }
    }

    componentDidMount(){

        this.state.ddl_options.tag.push("")
        this.state.ddl_options.country.push("")

        Window.react_data.projects.forEach((p) => {
            if(!this.state.ddl_options.tag.includes(p.tag)){
                this.state.ddl_options.tag.push(p.tag)
            } 

            if(!this.state.ddl_options.country.includes(p.country)){
                this.state.ddl_options.country.push(p.country)
            } 
        })
        this.setState({ddl_options: this.state.ddl_options});
    }

    render() {

        let projects = Window.react_data.projects.filter((p) => {
            return Object.keys(this.state.filters).reduce((acum, curr) => {
                let filter_val = this.state.filters[curr];
                if(filter_val && p[curr] != filter_val){
                    return false
                }
                
                return acum;
            }, true)
        })



        return (
            <div>
                <div className="bg-white">
                    <Navigation ref={this.navigation} />
                </div>
                <div className="container neutral-charcoal mt-3">
                    <h1>Våra Projekt</h1>
                    <p>Sök och hitta projekt för att förbättra världen ett steg i taget.</p>
                </div>
                <div className="container neutral-charcoal" style={{marginBottom:"64px"}}>
                    <div className="d-inline-block me-2 my-2">
                        <VBDropdown onChange={(val) => {this.setState({filters: {...this.state.filters, tag: val.value}})}} placeholder="Projekts Typ" options={this.state.ddl_options.tag.map((itm) => {return {"value": itm, "label": itm ? itm : "Alla"}})} inputStyle={{ minHeight: 0 }} />
                    </div>
                    <div className="d-inline-block me-2 my-2">
                        <VBDropdown onChange={(val) => {this.setState({filters: {...this.state.filters, country: val.value}})}} placeholder="Land" options={this.state.ddl_options.country.map((itm) => {return {"value": itm, "label": itm ? itm : "Alla"}})} inputStyle={{ minHeight: 0 }} />
                    </div>
                </div>

                <div className="container neutral-charcoal mb-3">
                    <div className="row">
                        {projects.map((p, i) => {
                            return <div style={{cursor:"pointer"}} className="col-12 col-lg-3 mb-2" onClick={() => {window.location = "/"+ p.attribute_label +"/" + p.id + "/"}}>
                            <div className="rounded-3 bg-neutral-stone-100 overflow-hidden" style={{height:"416px"}}>
                                <div className="w-100 d-flex justify-content-center align-items-center bg-neutral-stone-300" style={{height:"192px", objectFit:"cover"}}>
                                    <img className="bg-white p-3 rounded-circle overflow-visible " src={Window.static_path + "img/icons/leaf.svg"} style={{width:"100px", height:"100px"}} />
                                </div>
                                
                                <div className="p-2 position-relative" style={{height:"224px"}}>
                                    {/* upper half of card in this div */}
                                    <div className="pt-3 position-absolute top-0" style={{height:"112px"}}>
                                        <div className="mb-3">
                                            <span className="bg-supp-plum white rounded-5 py-1 px-2 n-caption-2">{p.tag}</span>
                                        </div>
                                        <p className="n-fs-6">{p.title} - {p.property_designation}</p>
                                    </div>
                                    {/* lower half of card in this div */}
                                    <div className="position-absolute bottom-0 pt-4" style={{height:"112px"}}>
                                        <p className="n-fs-6">{p.project_length} {p.project_length_unit}</p>
                                        <p className="position-absolute bottom-0 n-fs-7">{p.country}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        })}
                    </div>
                </div>
                
                <Footer/>
            </div >
        )
    }
}
export default NHListings;